/**
 * v3 react-tooltip required rebuild() after dynamic anchors changed.
 * v5 rebinds automatically — keep hook as a no-op so callers stay unchanged.
 */
export const useTooltipRebuild = (_deps = []) => {}
